import styled, { css } from "styled-components";

import { transition } from "@ui/helpers";

import { ButtonStyledProps } from "./Button.types";
import { getSize } from "./helpers/getSize";
import { getIconVariant } from "./helpers/getIconVariant";
import { getGreenVariant } from "./helpers/getGreenVariant";
import { getBlueVariant } from "./helpers/getBlueVariant";
import { getBlackVariant } from "./helpers/getBlackVariant";
import { getWhiteVariant } from "./helpers/getWhiteVariant";

export const Button = styled.button<ButtonStyledProps>`
  --button-border-radius: 4px;
  --button-border-size: 2px;

  all: unset;

  padding: var(--button-padding-v) var(--button-padding-h);
  color: var(--button-color);
  text-align: center;
  border-radius: var(--button-border-radius);
  background-color: var(--button-background-color);
  box-shadow: inset 0px 0px 0px var(--button-border-size)
    var(--button-border-color);
  transition: ${transition(["color", "background-color", "box-shadow"])};
  cursor: pointer;

  &:disabled {
    pointer-events: none;
  }

  ${props => getSize(props.$size)}
  ${props => props.$icon && getIconVariant(props.$icon)}
  ${props => props.$type === "green" && getGreenVariant(props.$style)}
  ${props => props.$type === "blue" && getBlueVariant(props.$style)}
  ${props => props.$type === "black" && getBlackVariant(props.$style)}
  ${props => props.$type === "white" && getWhiteVariant(props.$style)}
`;

type IconWrapperProps = Pick<ButtonStyledProps, "$icon" | "$size">;

export const IconWrapper = styled.span<IconWrapperProps>`
  position: relative;
  width: var(--button-icon-size);
  height: var(--button-icon-size);
  display: block;

  ${props =>
    props.$icon === "right" &&
    css`
      order: 1;
    `}

  ${Button}:has(&) {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: ${props => props.theme.spacing.spacing_8};

    ${props =>
      props.$size === "small" &&
      css`
        gap: ${props => props.theme.spacing.spacing_4};
      `}
  }

  > svg {
    position: absolute;
    inset: 0;
    min-width: 100%;
    min-height: 100%;
  }

  * {
    pointer-events: none;
  }
`;
